<template>
  <users-table></users-table>
</template>

<script>
import UsersTable from '@/components/app/users/UsersTable'

export default {
  name: "Users",
  components: {
    UsersTable
  }
}
</script>

<style scoped>

</style>